import React from 'react';
import PropTypes from 'prop-types';

export default function IconSettingFeatureMerchantFilled({ className }) {
  return (
    <svg className={className} fill="none" height="21" viewBox="0 0 18 21" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.8C0 0.805887 0.805888 0 1.8 0H10.2C11.1941 0 12 0.805888 12 1.8V8.4269C8.83372 8.71223 6.31224 11.2337 6.02691 14.4H4.2C3.86863 14.4 3.6 14.6686 3.6 15C3.6 15.3314 3.86863 15.6 4.2 15.6H6.02691C6.14958 16.9614 6.68564 18.2035 7.50859 19.2H1.8C0.805887 19.2 0 18.3941 0 17.4V1.8ZM12.6 20.4C15.5823 20.4 18 17.9823 18 15C18 12.0177 15.5823 9.6 12.6 9.6C9.61766 9.6 7.2 12.0177 7.2 15C7.2 17.9823 9.61766 20.4 12.6 20.4ZM15.4243 13.6243L11.8243 17.2243C11.59 17.4586 11.2101 17.4586 10.9757 17.2243L9.77574 16.0243C9.54142 15.7899 9.54142 15.41 9.77574 15.1757C10.01 14.9414 10.39 14.9414 10.6243 15.1757L11.4 15.9515L14.5757 12.7757C14.8101 12.5414 15.19 12.5414 15.4243 12.7757C15.6586 13.01 15.6586 13.3899 15.4243 13.6243Z" fill="currentColor"/>
    </svg>
  );
}

IconSettingFeatureMerchantFilled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

